import { useQuery } from "@tanstack/react-query";
import { fetchSingleStudyApi } from "@/API/fetchSingleStudyApi";
import { StudyDataType } from "@/types/apiTypes";
import { ShowNotification } from "@/components/ShowNotification";

export const useFetchSingleStudy = (studyId?: string) => {
  return useQuery<StudyDataType, Error>({
    queryKey: ["study", studyId],
    queryFn: () => {
      if (!studyId) {
        ShowNotification({
          title: "Error",
          message: "Study ID is required to fetch data.",
          color: "error",
        });
        throw new Error("Study ID not provided");
      }
      return fetchSingleStudyApi(studyId);
    },
    enabled: Boolean(studyId),
  });
};
